import { spaces } from '@kimuno/theme';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Relative heights of the bars: a burst that swells in the middle, as in the design. The
// animation is decorative; it does not follow the microphone level.
const BAR_HEIGHTS = [
	0.25, 0.4, 0.3, 0.55, 0.45, 0.75, 0.6, 1, 0.7, 0.9, 0.5, 0.8, 0.55, 0.65, 0.35, 0.45, 0.25,
];
const BAR_WIDTH = 2;
const WAVEFORM_HEIGHT = 24;

const visuallyHidden = {
	position: 'absolute',
	width: '1px',
	height: '1px',
	margin: '-1px',
	padding: 0,
	overflow: 'hidden',
	clip: 'rect(0 0 0 0)',
	whiteSpace: 'nowrap',
	border: 0,
} as const;

const DictationWaveform = () => {
	const { t } = useTranslation();

	return (
		<Box
			role="status"
			data-testid="ai-assistant-dictation-waveform"
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: `${BAR_WIDTH}px`,
				height: WAVEFORM_HEIGHT,
				padding: `${spaces.xs} ${spaces.sm}`,
				boxSizing: 'content-box',
			}}
		>
			<Box component="span" sx={visuallyHidden}>
				{t('Dictation in progress')}
			</Box>
			{BAR_HEIGHTS.map((height, index) => (
				<Box
					// biome-ignore lint/suspicious/noArrayIndexKey: a fixed decorative list that never reorders
					key={index}
					component="span"
					aria-hidden="true"
					sx={{
						width: BAR_WIDTH,
						height: height * WAVEFORM_HEIGHT,
						borderRadius: `${BAR_WIDTH}px`,
						bgcolor: 'text.secondary',
						animation: 'dictationWave 1.2s ease-in-out infinite',
						animationDelay: `${(index % 5) * 0.15}s`,
						'@keyframes dictationWave': {
							'0%, 100%': { transform: 'scaleY(0.4)' },
							'50%': { transform: 'scaleY(1)' },
						},
						'@media (prefers-reduced-motion: reduce)': {
							animation: 'none',
						},
					}}
				/>
			))}
		</Box>
	);
};

export default DictationWaveform;
